import axios from "axios";
import { getApiUrl } from "../../../services/Config";

const baseApiUrl = getApiUrl();
export const LOGIN_URL = baseApiUrl + "/api/User/Login";
export const LOGOUT_URL = baseApiUrl + "/api/User/Logout";
export const LOGOUT_WITHOUT_LOGIN_URL =
  baseApiUrl + "/api/User/LogoutUserNotLogin";
export const INITIAL_INFO_URL = baseApiUrl + "/api/General/GetActivatorInfo";
export const OTP_URL = baseApiUrl + "/api/User/SendLoginSMS";
export const SNED_SMS_URL = baseApiUrl + "/api/User/SendSMS";
export const LOGIN_WITH_OTP_URL = baseApiUrl + "/api/User/LoginWithSMS";
export const REFRESH_URL = baseApiUrl + "/api/User/GetTokenByRefreshToken";
export const REQUEST_PASSWORD_URL = baseApiUrl + "/api/User/RequestPassword";
export const CHANGE_PASSWORD_URL = baseApiUrl + "/api/User/ChangePassword";
export const CHANGE_MOBILE_URL = baseApiUrl + "/api/User/ChangeMobile";
export const CREATE_DETAIL_URL = baseApiUrl + "/api/UserDetail/Create";

export const SEND_OPT_URL = baseApiUrl + "/api/User/opt";
export const ME_URL = baseApiUrl + "/api/User/Get/22";
export const REGISTER_URL = baseApiUrl + "/api/User/register";
export const SSOINFO_URL = baseApiUrl + "/api/General/GetSSOInfo";
export const LOGIN_WITH_OAUTH2TEMPCODE_URL =
  baseApiUrl + "/api/User/LoginByOAuth2";
export const SYSTEM_VERSION_URL = baseApiUrl + "/api/SystemInfo/version";

export function sendOTP(username, password) {
  return axios.post(OTP_URL, {
    username,
    password,
  });
}

export function sendSms(username, password, mobile) {
  return axios.post(SNED_SMS_URL, {
    username,
    password,
    mobile,
  });
}

export function login(username, password, otp = "") {
  return axios.post(LOGIN_URL, {
    username,
    password,
    otp,
  });
}

export function logout() {
  return axios.post(LOGOUT_URL);
}

export function logoutNotLogin(userId) {
  return axios.post(LOGOUT_WITHOUT_LOGIN_URL, {
    userId,
  });
}

export function getInitialInfo() {
  return axios.get(`${INITIAL_INFO_URL}`);
}

// export function loginWithOTP(username, password, otp) {
//   return axios.post(LOGIN_WITH_OTP_URL, {
//     username,
//     password,
//     otp
//   })
// }

export function changePassword(username, oldPassword, newPassword) {
  return axios.post(CHANGE_PASSWORD_URL, {
    username,
    oldPassword,
    newPassword,
  });
}

export function changeMobile(id, mobile, smsCode) {
  return axios.post(CHANGE_MOBILE_URL, {
    id,
    mobile,
    smsCode,
  });
}

export function createUserDetail(object) {
  return axios.post(CREATE_DETAIL_URL, object);
}

export function getNewToken(username, refreshToken) {
  return axios.post(REFRESH_URL, {
    username,
    refreshToken,
  });
}

export function requestPassword(username, mobile) {
  return axios.post(REQUEST_PASSWORD_URL, {
    username,
    mobile,
  });
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  // return axios.get(ME_URL);
  return axios.get(ME_URL);
}

export function getSSOInfo() {
  return axios.get(SSOINFO_URL);
}

export function loginByOAuth2(code, state) {
  return axios.post(LOGIN_WITH_OAUTH2TEMPCODE_URL, {
    code,
    state,
  });
}

export function getSystemVersion() {
  return axios.get(SYSTEM_VERSION_URL);
}
